import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddParentComponent } from './add-parent/AddParentComponent';

const ParentProfileRoutes: Routes = [
    { path : 'profile', 
        children:[
            {
                path: 'add-parent',
                component: AddParentComponent
            },
            {
                path: 'edit-parent',
                component: AddParentComponent
            }
    ] }
];

export const parentProfileRouting: ModuleWithProviders = RouterModule.forChild(ParentProfileRoutes);


// WEBPACK FOOTER //
// ./src/holiday/parent/profile/parent/ParentProfileRouting.ts